import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cgw-section-title',
  standalone: true,
  imports: [],
  templateUrl: './section-title.component.html',
  styleUrl: './section-title.component.scss',
})
export class SectionTitleComponent implements OnInit {
  @Input() text: string;
  public parts: { text: string; bold: boolean }[] = [];

  public ngOnInit(): void {
    this.parts = this.parseText(this.text);
  }

  private parseText(text: string): { text: string; bold: boolean }[] {
    return (text.match(/(<b>.*?<\/b>|[^<]+)/g) || []).map((part) => {
      if (part.startsWith('<b>') && part.endsWith('</b>')) {
        return { text: part.slice(3, -4), bold: true };
      } else {
        return { text: part, bold: false };
      }
    });
  }
}
